function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.584 16H30.816V6.944L34.896 12.928H34.96L39.04 6.928V16H40.304V4.8H39.024L34.944 10.912L30.864 4.8H29.584V16ZM44.1146 16H45.4106L46.7386 13.04H52.8346L54.1466 16H55.5066L50.4026 4.72H49.2186L44.1146 16ZM47.2346 11.888L49.7946 6.192L52.3386 11.888H47.2346ZM59.3153 16H60.5793V11.648H63.7793L67.0273 16H68.5793L65.1393 11.424C66.8993 11.104 68.1793 10.016 68.1793 8.16V8.128C68.1793 7.248 67.8593 6.464 67.3153 5.92C66.6113 5.216 65.5073 4.8 64.1313 4.8H59.3153V16ZM60.5793 10.512V5.968H64.0353C65.8433 5.968 66.8993 6.8 66.8993 8.176V8.208C66.8993 9.648 65.6993 10.512 64.0193 10.512H60.5793ZM72.4777 16H73.7417V12.992L76.1257 10.576L80.4297 16H82.0138L77.0057 9.696L81.8057 4.8H80.1737L73.7417 11.488V4.8H72.4777V16ZM85.5778 16H93.7538V14.848H86.8418V10.928H92.9538V9.776H86.8418V5.952H93.6738V4.8H85.5778V16ZM100.857 16H102.137V5.968H105.897V4.8H97.0965V5.968H100.857V16Z",
  fill: "black",
  fillOpacity: 0.7
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.6257 4.12829C14.8093 4.16329 14.9815 4.03498 14.993 3.83669C15.0389 2.95023 14.9815 0.76906 13.558 0.232516C11.6982 -0.467324 8.7134 0.512452 6.41738 1.84215C4.08692 3.19517 1.15949 6.34445 0 9.55205C0 9.55205 4.31652 5.76125 8.74784 4.65317C12.1 3.81336 13.9254 3.98833 14.6257 4.12829Z",
  fill: "#64666B"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.74337 9.66883C3.68597 9.49387 3.47933 9.40055 3.31861 9.49387C2.53796 9.90211 0.712621 11.0335 0.965184 12.5615C1.29811 14.5444 3.62857 16.6906 5.90163 18.0436C8.20913 19.4199 12.3534 20.4114 15.6712 19.8282C15.6712 19.8282 10.2755 17.9269 7.11852 14.5794C4.73066 12.0483 3.97297 10.357 3.74337 9.66883Z",
  fill: "#64666B"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.9495 16.5504C13.8233 16.6904 13.8577 16.912 14.0069 17.017C14.7417 17.4952 16.6244 18.545 17.7954 17.5535C19.3222 16.2705 19.9766 13.1446 19.9996 10.4618C20.011 7.74412 18.7941 3.6034 16.6474 0.979004C16.6474 0.979004 17.7265 6.67104 16.4522 11.1267C15.4764 14.4859 14.4202 16.0139 13.9495 16.5504Z",
  fill: "#64666B"
});

var SvgMarket = function SvgMarket(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 109 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/market.bb8e13bc.svg";
export { ForwardRef as ReactComponent };